const getNewsImage = ({newsArticle}) =>
  newsArticle?.media?.find?.((media) => media.type === 'image')?.url || null;

export default getNewsImage;
